module.exports = __webpack_public_path__ + "static/media/edit_icon.174ba7e5.svg";